export const environment = {
  production: true,
  apiUrl: "https://trea-condominios-api.herokuapp.com/condo/api"
};
